import { render, staticRenderFns } from "./create-zip.component.vue?vue&type=template&id=2db19eb2&scoped=true"
import script from "./create-zip.component.vue?vue&type=script&lang=js"
export * from "./create-zip.component.vue?vue&type=script&lang=js"
import style0 from "./create-zip.component.vue?vue&type=style&index=0&id=2db19eb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db19eb2",
  null
  
)

export default component.exports